import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDownloadAction } from '../../../../ts/ServerApi/types/actionNames';
import { download } from '../../../actions/spaces/DownloadAction';
import { IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const DownloadEntityAction: IEntityAction<IContentInfo<'workbook' | 'datasource' | 'flow'>, IDownloadAction> = {
  name: 'download',
  translateName: Messages.download_action,
  isVisible: (targetItems: IContentInfo<'datasource' | 'workbook' | 'flow'>[]) => {
    return !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IDownloadAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.download,
  createReduxAction: (items: IContentInfo[]) => download(items[0])
};
